import { render } from "./BtnNav.vue?vue&type=template&id=7f3b4c31&scoped=true"
import script from "./BtnNav.vue?vue&type=script&lang=js"
export * from "./BtnNav.vue?vue&type=script&lang=js"

import "./BtnNav.vue?vue&type=style&index=0&id=7f3b4c31&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3b4c31"]])

export default __exports__